import { useSelector } from 'react-redux';

import { getAllInlineSelectedBets } from 'redux/modules/inlinePlacement/selectors';

import InlinePlacementInjectionItem from './components/InlinePlacementInjectionItem/InlinePlacementInjectionItem';

const InlinePlacementInjection = () => {
  const bets = useSelector(getAllInlineSelectedBets);

  return (
    <>
      {bets.map(bet => (
        <InlinePlacementInjectionItem bet={bet} key={bet.betUuid} />
      ))}
    </>
  );
};

export default InlinePlacementInjection;
